<template>
  <li v-if="showable"
      :class="[className, {has_subpages: hasSubPages}, { active: active }]"
      @click.stop.prevent="toggle"
  >
    <router-link :to="{ name: linkName }">
      <slot></slot>
    </router-link>
    <ul v-if="hasSubPages">
      <navigation-item
          v-for="item in subPages"
          :key="item.id"
          :class-name="item.className"
          :link-name="item.linkName"
          :section-name="item.sectionName"
          :routes="item.routes"
          :sub-pages="item.subPages"
          :always-allowed="item.alwaysAllowed"
          @clicked="onClick"
          :ref="getItemRefId(item.id)"
      >{{ item.title }}
      </navigation-item>
    </ul>
  </li>
</template>

<script>
import userSettings from "@/components/mixins/user-settings"

export default {
  name: "NavigationItem",
  mixins: [userSettings],
  props: {
    className: String,
    linkName: String,
    sectionName: String,
    routes: Array,
    subPages: Array,
    alwaysAllowed: Boolean,
  },
  data() {
    return {
      active: false,
    }
  },
  created() {
    this.active = this.isActiveRoute();
  },
  computed: {
    hasSubPages() {
      return this.subPages && this.subPages.length > 0
    },
    showable() {
      if(this.sectionName === 'operators') {
        return this.$_loggedUser_action_allowed('operators', 'read', 'ALL');
      }

      return !((!this.hasSubPages && !this.alwaysAllowed && !this.$_loggedUser_action_allowed(this.sectionName, 'read', null))
          || (this.hasSubPages && !this.atLeastOneSubPageAllowed));
    },

    atLeastOneSubPageAllowed(){
      for(const item of this.subPages){
        if(this.$_loggedUser_action_allowed(item.sectionName, 'read')){
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    toggle(e) {
      if (this.hasSubPages) {
        if(!this.active || !this.$store.getters.isNavigationOpened) {
          this.$emit('clickOpen');
          this.active = true
        }else{
          this.active = false;
        }
        this.$emit('clickOpen');
      } else {
        this.active = true;
        this.$router.push({name: this.linkName})
        this.$emit('clicked', e.pointerType);
      }
    },
    onClick(type){
      this.$emit('clicked', type);
    },
    isActiveRoute() {
      if (this.hasSubPages) {
        let routes = []
        this._.forEach(this.subPages, (item) => {
          routes = this._.union(routes, item.routes)
        })

        return routes.includes(this.$route.name);
      } else {
        return this.routes.includes(this.$route.name);
      }
    },
    closeIfNotActive() {
      this.active = this.isActiveRoute()
      if(this.hasSubPages) {
        this.subPages.forEach(function (item) {
          if (this.$refs[this.getItemRefId(item.id)] && this.$refs[this.getItemRefId(item.id)][0]) {
            this.$refs[this.getItemRefId(item.id)][0].closeIfNotActive()
          }
        }.bind(this))
      }
    },
    isShowable(){
      return this.showable;
    },
    getItemRefId(id) {
      return 'nav-sub-item-' + id
    }
  },
  watch: {
    $route() {
      this.active = this.isActiveRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavigationItem.vue